export const DELETE_GATEWAY_REQUEST = 'gatewayDetails/DELETE_GATEWAY_REQUEST';
export const DELETE_GATEWAY = 'gatewayDetails/DELETE_GATEWAY';
export const CLEAR_STORE = 'gatewayDetails/deleteGateway/CLEAR_STORE';
